<template>
  <div class="nav-block" v-if="items?.length">
    <div class="container">
      <div class="row justify-content-center">
        <div class="one-min-sub" v-for="item in items" :key="item.id || item.text">
          <div class="one-min-sub-tit">
            <a :href="item.link" class="">
              <div class="imgWraper" v-if="item.img" v-html="item.img"></div>
              {{ item.text }}
              <span v-if="item.children?.length > 0"></span>
            </a>

            <NavigationBlock
                v-if="item.children?.length"
                :items="item.children"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationBlock',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>